import { CERBERUS_STATS_FIELDS, CerberusStatsFields } from '@hcs/types';

const caclculateInactive = (
  defaultOrder: CerberusStatsFields[],
  defaultActive: CerberusStatsFields[],
): CerberusStatsFields[] => {
  return defaultOrder.reduce<CerberusStatsFields[]>((accum, field) => {
    if (defaultActive.indexOf(field) === -1) {
      accum.push(field);
    }
    return accum;
  }, []);
};

export const CERBERUS_STATS_ALL_FIELDS: CerberusStatsFields[] = [
  CERBERUS_STATS_FIELDS.daysOnMarketMedian,
  CERBERUS_STATS_FIELDS.daysOnMarketMedianRental,
  CERBERUS_STATS_FIELDS.daysOnMarketMedianMovingAvg,
  CERBERUS_STATS_FIELDS.daysOnMarketMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.daysOnMarketNotContractMedian,
  CERBERUS_STATS_FIELDS.daysOnMarketNotContractMedianRental,
  CERBERUS_STATS_FIELDS.daysOnMarketNotContractMedianMovingAvg,
  CERBERUS_STATS_FIELDS.daysOnMarketNotContractMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.daysToCloseMedian,
  CERBERUS_STATS_FIELDS.daysToCloseMedianRental,
  CERBERUS_STATS_FIELDS.daysToCloseMedianMovingAvg,
  CERBERUS_STATS_FIELDS.daysToCloseMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.daysToContractMedian,
  CERBERUS_STATS_FIELDS.daysToContractMedianRental,
  CERBERUS_STATS_FIELDS.daysToContractMedianMovingAvg,
  CERBERUS_STATS_FIELDS.daysToContractMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.daysToFirstPriceDropMedian,
  CERBERUS_STATS_FIELDS.daysToFirstPriceDropMedianRental,
  CERBERUS_STATS_FIELDS.daysToFirstPriceDropMedianMovingAvg,
  CERBERUS_STATS_FIELDS.daysToFirstPriceDropMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsClosedCount,
  CERBERUS_STATS_FIELDS.listingsClosedCountRental,
  CERBERUS_STATS_FIELDS.listingsClosedCountMovingAvg,
  CERBERUS_STATS_FIELDS.listingsClosedCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsNewCount,
  CERBERUS_STATS_FIELDS.listingsNewCountRental,
  CERBERUS_STATS_FIELDS.listingsNewCountMovingAvg,
  CERBERUS_STATS_FIELDS.listingsNewCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsOnMarketCount,
  CERBERUS_STATS_FIELDS.listingsOnMarketCountRental,
  CERBERUS_STATS_FIELDS.listingsOnMarketCountMovingAvg,
  CERBERUS_STATS_FIELDS.listingsOnMarketCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsPriceChangeCount,
  CERBERUS_STATS_FIELDS.listingsPriceChangeCountRental,
  CERBERUS_STATS_FIELDS.listingsPriceChangeCountMovingAvg,
  CERBERUS_STATS_FIELDS.listingsPriceChangeCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsPriceDropCount,
  CERBERUS_STATS_FIELDS.listingsPriceDropCountRental,
  CERBERUS_STATS_FIELDS.listingsPriceDropCountMovingAvg,
  CERBERUS_STATS_FIELDS.listingsPriceDropCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsPriceDropPercent,
  CERBERUS_STATS_FIELDS.listingsPriceDropPercentRental,
  CERBERUS_STATS_FIELDS.listingsPriceDropPercentMovingAvg,
  CERBERUS_STATS_FIELDS.listingsPriceDropPercentMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsRemovedCount,
  CERBERUS_STATS_FIELDS.listingsRemovedCountRental,
  CERBERUS_STATS_FIELDS.listingsRemovedCountMovingAvg,
  CERBERUS_STATS_FIELDS.listingsRemovedCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsRemovedPercent,
  CERBERUS_STATS_FIELDS.listingsRemovedPercentRental,
  CERBERUS_STATS_FIELDS.listingsRemovedPercentMovingAvg,
  CERBERUS_STATS_FIELDS.listingsRemovedPercentMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsUnderContractCount,
  CERBERUS_STATS_FIELDS.listingsUnderContractCountRental,
  CERBERUS_STATS_FIELDS.listingsUnderContractCountMovingAvg,
  CERBERUS_STATS_FIELDS.listingsUnderContractCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsUnderContractPercent,
  CERBERUS_STATS_FIELDS.listingsUnderContractPercentRental,
  CERBERUS_STATS_FIELDS.listingsUnderContractPercentMovingAvg,
  CERBERUS_STATS_FIELDS.listingsUnderContractPercentMovingAvgRental,
  CERBERUS_STATS_FIELDS.marketGrade,
  CERBERUS_STATS_FIELDS.monthsOfSupplyMedian,
  CERBERUS_STATS_FIELDS.monthsOfSupplyMedianRental,
  CERBERUS_STATS_FIELDS.monthsOfSupplyMedianMovingAvg,
  CERBERUS_STATS_FIELDS.monthsOfSupplyMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.netPopulationGrowth,
  CERBERUS_STATS_FIELDS.priceClosedMedian,
  CERBERUS_STATS_FIELDS.priceClosedMedianRental,
  CERBERUS_STATS_FIELDS.priceClosedMedianMovingAvg,
  CERBERUS_STATS_FIELDS.priceClosedMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.priceNewListMedian,
  CERBERUS_STATS_FIELDS.priceNewListMedianRental,
  CERBERUS_STATS_FIELDS.priceNewListMedianMovingAvg,
  CERBERUS_STATS_FIELDS.priceNewListMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.priceOnMarketMedian,
  CERBERUS_STATS_FIELDS.priceOnMarketMedianRental,
  CERBERUS_STATS_FIELDS.priceOnMarketMedianMovingAvg,
  CERBERUS_STATS_FIELDS.priceOnMarketMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.priceOnMarketMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.pricePerSqftClosedMedian,
  CERBERUS_STATS_FIELDS.pricePerSqftClosedMedianRental,
  CERBERUS_STATS_FIELDS.pricePerSqftClosedMedianMovingAvg,
  CERBERUS_STATS_FIELDS.pricePerSqftClosedMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.pricePerSqftNewListMedian,
  CERBERUS_STATS_FIELDS.pricePerSqftNewListMedianRental,
  CERBERUS_STATS_FIELDS.pricePerSqftNewListMedianMovingAvg,
  CERBERUS_STATS_FIELDS.pricePerSqftNewListMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.pricePerSqftOnMarketMedian,
  CERBERUS_STATS_FIELDS.pricePerSqftOnMarketMedianRental,
  CERBERUS_STATS_FIELDS.pricePerSqftOnMarketMedianMovingAvg,
  CERBERUS_STATS_FIELDS.pricePerSqftOnMarketMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.return1YearForecast,
  CERBERUS_STATS_FIELDS.risk1YearLoss,
  CERBERUS_STATS_FIELDS.rpiReturn1Year,
  CERBERUS_STATS_FIELDS.saleToListPriceMedian,
  CERBERUS_STATS_FIELDS.saleToListPriceMedianRental,
  CERBERUS_STATS_FIELDS.saleToListPriceMedianMovingAvg,
  CERBERUS_STATS_FIELDS.saleToListPriceMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.saleToListPriceOriginalMedian,
  CERBERUS_STATS_FIELDS.saleToListPriceOriginalMedianRental,
  CERBERUS_STATS_FIELDS.saleToListPriceOriginalMedianMovingAvg,
  CERBERUS_STATS_FIELDS.saleToListPriceOriginalMedianMovingAvgRental,
];

// fields not available at the MSA level
const NOT_AVAILABLE_IN_MSA_FIELDS: CerberusStatsFields[] = [
  CERBERUS_STATS_FIELDS.marketGrade,
];

// it's easier to list the active fields and just calculate the inactive ones from the total
const CHARTS_DEFAULT_ACTIVE: CerberusStatsFields[] = [
  CERBERUS_STATS_FIELDS.listingsOnMarketCount,
  CERBERUS_STATS_FIELDS.saleToListPriceOriginalMedian,
  CERBERUS_STATS_FIELDS.daysOnMarketMedian,
  CERBERUS_STATS_FIELDS.priceOnMarketMedian,
  CERBERUS_STATS_FIELDS.monthsOfSupplyMedian,
];

const NO_CHARTS_FIELDS: CerberusStatsFields[] = [
  CERBERUS_STATS_FIELDS.netPopulationGrowth,
  CERBERUS_STATS_FIELDS.marketGrade,
  CERBERUS_STATS_FIELDS.risk1YearLoss,
  CERBERUS_STATS_FIELDS.return1YearForecast,
  CERBERUS_STATS_FIELDS.rpiReturn1Year,
];

const notAvailableInMsaFilterFn = (field: CerberusStatsFields) =>
  NOT_AVAILABLE_IN_MSA_FIELDS.indexOf(field) === -1;

const ALL_CHARTS_ORDER: CerberusStatsFields[] = [
  ...CHARTS_DEFAULT_ACTIVE,
  // add the rest of fields that aren't in default active list or other fields we don't want for the charts
  ...CERBERUS_STATS_ALL_FIELDS.filter(
    (field) =>
      CHARTS_DEFAULT_ACTIVE.indexOf(field) === -1 &&
      NO_CHARTS_FIELDS.indexOf(field) === -1,
  ),
];

export const MARKET_STATE_MSA_ALL_CHARTS_ORDER: CerberusStatsFields[] = [
  ...ALL_CHARTS_ORDER.filter(notAvailableInMsaFilterFn),
];

export const MARKET_STATE_MSA_CHARTS_DEFAULT_INACTIVE: CerberusStatsFields[] =
  caclculateInactive(
    MARKET_STATE_MSA_ALL_CHARTS_ORDER,
    CHARTS_DEFAULT_ACTIVE.filter(notAvailableInMsaFilterFn),
  );

export const MARKET_STATE_ZIP_ALL_CHARTS_ORDER: CerberusStatsFields[] = [
  ...ALL_CHARTS_ORDER,
];

export const MARKET_STATE_ZIP_CHARTS_DEFAULT_INACTIVE: CerberusStatsFields[] =
  caclculateInactive(MARKET_STATE_ZIP_ALL_CHARTS_ORDER, CHARTS_DEFAULT_ACTIVE);

const COLUMNS_DEFAULT_ACTIVE: CerberusStatsFields[] = [
  CERBERUS_STATS_FIELDS.return1YearForecast,
  CERBERUS_STATS_FIELDS.grossYieldMedian,
  CERBERUS_STATS_FIELDS.saleToListPriceOriginalMedian,
  CERBERUS_STATS_FIELDS.monthsOfSupplyMedian,
  CERBERUS_STATS_FIELDS.listingsOnMarketCount,
];

const ALL_COLUMNS_ORDER: CerberusStatsFields[] = [
  ...COLUMNS_DEFAULT_ACTIVE,
  // add the rest of fields that aren't in default active list
  ...CERBERUS_STATS_ALL_FIELDS.filter(
    (field) => COLUMNS_DEFAULT_ACTIVE.indexOf(field) === -1,
  ),
];

export const MARKET_STATE_MSA_ALL_COLUMNS_ORDER: CerberusStatsFields[] = [
  ...ALL_COLUMNS_ORDER.filter(notAvailableInMsaFilterFn),
];

export const MARKET_STATE_MSA_COLUMNS_DEFAULT_INACTIVE: CerberusStatsFields[] =
  caclculateInactive(
    MARKET_STATE_MSA_ALL_COLUMNS_ORDER,
    COLUMNS_DEFAULT_ACTIVE.filter(notAvailableInMsaFilterFn),
  );

export const MARKET_STATE_ZIP_ALL_COLUMNS_ORDER: CerberusStatsFields[] = [
  ...ALL_COLUMNS_ORDER,
];

export const MARKET_STATE_ZIP_COLUMNS_DEFAULT_INACTIVE: CerberusStatsFields[] =
  caclculateInactive(
    MARKET_STATE_ZIP_ALL_COLUMNS_ORDER,
    COLUMNS_DEFAULT_ACTIVE,
  );

export const MARKET_STATE_CITY_ALL_CHARTS_ORDER: CerberusStatsFields[] = [
  ...ALL_CHARTS_ORDER,
];

export const MARKET_STATE_CITY_CHARTS_DEFAULT_INACTIVE: CerberusStatsFields[] =
  caclculateInactive(MARKET_STATE_CITY_ALL_CHARTS_ORDER, CHARTS_DEFAULT_ACTIVE);

export const MARKET_STATE_CITY_ALL_COLUMNS_ORDER: CerberusStatsFields[] = [
  ...ALL_COLUMNS_ORDER,
];

export const MARKET_STATE_CITY_COLUMNS_DEFAULT_INACTIVE: CerberusStatsFields[] =
  caclculateInactive(
    MARKET_STATE_CITY_ALL_COLUMNS_ORDER,
    COLUMNS_DEFAULT_ACTIVE,
  );

export const CERBERUS_STATS_NON_FILTER_FIELDS: CerberusStatsFields[] = [
  CERBERUS_STATS_FIELDS.displayName,
  CERBERUS_STATS_FIELDS.hpiLatestMonth,
  CERBERUS_STATS_FIELDS.listingStatsEventDate,
  CERBERUS_STATS_FIELDS.listingStatsEventDateRental,
  CERBERUS_STATS_FIELDS.populationLatestMonth,
  CERBERUS_STATS_FIELDS.rpiLatestMonth,
];
